
import { supabase } from '@/lib/supabase'

export const signIn = async (email: string, password: string) => {
  console.log('Tentative de connexion:', email)
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    })
    
    if (error) {
      console.error('Erreur lors de la connexion:', error)
      
      // Détection améliorée pour les erreurs liées à un email non confirmé
      if (error.message?.includes("Email not confirmed") || 
          error.message?.toLowerCase().includes("not confirmed") ||
          error.message?.includes("non confirmé") ||
          error.message?.includes("non vérifié") ||
          error.message?.includes("verify") ||
          error.message?.includes("verification") ||
          error.code === "email_not_confirmed" ||
          error.code === "400") {
        console.log('Erreur détectée: Email non confirmé')
        // Créer une erreur personnalisée avec un message clair
        return { 
          data: null, 
          error: new Error("Veuillez confirmer votre adresse email avant de vous connecter. Vérifiez votre boîte de réception.") 
        }
      }
      
      // Pour les autres types d'erreurs
      return { data: null, error }
    }
    
    console.log('Connexion réussie:', data)
    return { data, error: null }
  } catch (error) {
    console.error('Exception lors de la connexion:', error)
    return { data: null, error }
  }
}
